import React from "react";
import toast from "react-hot-toast";

const ShowDetails = (id: string) => {
  return (
    <a
      style={{ textDecoration: "underline", cursor: "pointer" }}
      onClick={() => {
        toast.dismiss(id);
      }}
    >
      Details
    </a>
  );
};

export default ShowDetails;
